import React from 'react';
import { connect } from 'react-redux';

import classes from './HotelAbout.scss';

const formatDateHandler = (time) => {
    var ts = time;
    var H = +ts.substr(0, 2);
    var h = (H % 12) || 12;
    h = (h < 10)?("0"+h):h;  // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " AM" : " PM";
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
}

const hotelAbout = (props) => (
    <div className={`u-relative`}>
        <div className={`${classes.Video} u-relative u-backgroundColorPrimary`}>
            <img src={props.hotelImages[0].url} alt="Hotel" className={`u-block u-width100Percent u-height100Percent`} />
            <div className={`${classes.DetailLongBar} u-phoneHide`}></div>
        </div>
        <div className={classes.Detail}>
            <div className={`${classes.DetailShortBar} u-phoneHide`}></div>
            <div className="u-flex mb-3 u-fontSize14">
                <p><span className="u-fontWeightMedium u-textColorNormal">CheckIn: </span><span className="u-fontWeightNormal">{formatDateHandler(props.checkIn)}</span></p>
                <p className="u-textColorDark ml-3 mr-3">|</p>
                <p><span className="u-fontWeightMedium u-textColorNormal">CheckOut: </span><span className="u-fontWeightNormal">{formatDateHandler(props.checkOut)}</span></p>
            </div>
            <div className={`mb-4 u-height100Percent u-overflowScrollY`}>
                <p className={`u-textColorNormal`} style={{lineHeight: '2.4rem'}}>{props.description}</p>
            </div>
        </div>
    </div>
);

const mapStateToProps = state => {
    return {
        description: state.hotels.detailDescription,
        hotelImages: state.hotels.hotelImages,
        checkIn: state.hotels.checkIn,
        checkOut: state.hotels.checkOut
    }
}

export default connect(mapStateToProps)(hotelAbout);


// WEBPACK FOOTER //
// ./src/components/HotelDetail/HotelAbout/HotelAbout.js